<template>
    <div class="radios">
        <p class="supertitle" v-if="questionNumber">otázka {{ questionNumber }}</p>
        <h2 class="title">{{ title }}</h2>
        <p class="subtitle subtitle--mb" v-if="subtitle">{{ subtitle }}</p>
        <ul class="radios__list">
            <li v-for="(question, i) in questions" :key="`${name}-${i}`" class="radios__item" :class="{'radios__item--expanded': question.active, 'radios__item--no-expand': question.hideControls}">
                <div class="radios__label" :class="{
                        'radios__label--no-controls': question.hideControls,
                        'radios__label--active': question.active
                    }"
                    @click="updateValue(question, i)">
                    <span class="radios__text">
                        <div class="radios__close" v-if="question.active && !question.hideControls" v-on:click.stop="closeQuestion(question, i)">
                            <svg fill="none" class="radios__close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M1 1l14 14M1 15L15 1" stroke="#1A3066" stroke-width="2"/></svg>
                        </div>
                        {{ question.text }}
                    </span>
                    <span class="radios__controls" v-if="!question.hideControls">
                        <GroheFrequency :unit="unit" :value-per-unit="valuePerUnit" :embeded="true" :name="question.text"></GroheFrequency>
                    </span>
                </div>
            </li>
        </ul>
        <span class="radios__error" v-if="$v.value.$error && !$v.value.required">Odpovězte prosím na otázku</span>
    </div>
</template>

<script>
import GroheFrequency from "@/components/GroheFrequency";
import GroheRadios from "@/components/GroheRadios";
export default {
    name: "GroheExpandingRadios",
    extends: GroheRadios,
    components: {
        GroheFrequency
    },
    props: {
        unit: {
            type: String,
            required: true
        },
        valuePerUnit: {
            type: Number,
            required: true
        },
        questionNumber: {
            type: String
        },
        subtitle: {
            type: String
        },
    },
    data() {
        return {
            currentIndex: null,
            questions: null
        }
    },
    computed: {
        consumption() {
            if (!this.questions) return null;
            return this.questions
                .filter(q => q.active)
                .map((q, i) => {
                    const childComp = this.$children.find(comp => comp.name === q.text);
                    const frequency = childComp && childComp.consumption;
                    if (!frequency) return 0;
                    return parseFloat((frequency * q.value).toFixed(1));
                })
                .reduce((accum, val) => accum += val, 0)
        },
        allInactive() {
            return this.questions.every(q => !q.active)
        }
    },
    methods: {
        updateValue(question, index) {
            if (question.hideControls) {
                question.active = !question.active;
            }
            else {
                question.active = true
            }
            if (!this.value) this.value = 0;
            this.$set(this.questions, index, question);
        },
        closeQuestion(question, index) {
            question.active = !question.active;
            this.$set(this.questions, index, question)
        },
        validate() {
            if (this.allInactive) this.value = null;
            this.$v.form.$touch();
            const isValid = !this.$v.form.$invalid;
            this.$emit('on-validate', isValid, this.name, this.value);
            return isValid;
        }
    },
    watch: {
        consumption(newVal) {
            this.value = newVal
        }
    },
    mounted() {
        this.questions = this.items.map(i => {
            const question = i;
            question.active = false;
            return question;
        })
    }
}
</script>

<style scoped lang="scss">
.radios {
    $this: &;
    &__list {
        width: 100%;
        min-width: initial;
    }
    &__item {
        margin-left: auto;
        margin-right: auto;
        height: 60px;
        transition: all .3s ease-out;
        &--expanded:not(#{$this}__item--no-expand) {
            height: 120px;

            #{$this}__label {
                border-radius: 20px;
                align-items: flex-start;
            }
            #{$this}__controls {
                display: block;
                width: 100%;
                left: -2px;
                bottom: -2px;
            }
            #{$this}__text {
                //padding-top: 7px;
                display: flex;
                height: 60px;
                margin-top: -15px;
                align-items: center;
            }
        }
        &--no-expand {
            height: 60px !important;
        }
    }
    &__label {
        padding: 15px 20px;
        height: 100%;
        font-size: 14px;
        border-color: $sailor-boy;

        &--active#{$this}__label--no-controls {
            border-color: $crow-black-blue;
            background-color: $calcareous-sinter;
        }
        &:before {
            display: none;
        }
    }
    &__controls {
        display: none;
        position: absolute;
    }
    &__close {
        width: 30px;
        height: 30px;
        display: inline-flex;
        font-size: 30px;
        padding-right: 15px;
        z-index: 1;
    }
    &__close-icon {
        width: 16px;
    }

    @media screen and (min-width: $mq-sm) {
        &__label {
            font-size: 16px;
        }
    }

    @media screen and (min-width: $mq-md) {
        &__list {
            width: 750px;
        }
        &__item {
            width: 500px;

            &--no-expand {
                width: 500px !important;
            }
            &--expanded {
                width: 100%;
                height: 60px !important;

                #{$this}__controls {
                    display: inline-flex !important;
                    justify-content: flex-end;
                }
            }
        }
        &__label {
            border-radius: 100px !important;
            align-items: center !important;
        }
        &__text {
            height: auto !important;
            margin-top: 0 !important;
        }
        &__controls {
            top: -2px;
            right: 0;
            left: auto !important;
            bottom: auto !important;
        }
    }
}
</style>
